import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/fibonacci-2',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/saad.mankarious/',
    label: 'Facebook',
    icon: faFacebookF,
  },
  // {
  //   link: 'https://www.instagram.com/dangelosaurus/',
  //   label: 'Instagram',
  //   icon: faInstagram,
  // },
  {
    link: 'https://www.linkedin.com/in/saadmankarious/?locale=en_US',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'mailto:saadm@gwu.edu',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
